import * as Yup from "yup";
import Select from "react-select";
import { Form, Formik } from "formik";
import { toast } from "react-toastify";
import { PropagateLoader } from "react-spinners";
import Button from "../../atoms/Button";
import InputField from "../../atoms/InputField";
import SubHeading from "../../atoms/SubHeading";
import { UPDATE_INMUEBLE } from "../../../api/apiInmuebles";
import { optionsTypesInmuebles } from "../../../utils/optionsTypesInmuebles";

const InmueblesEdit = ({ inmueble, refetch, onClose }) => {
    const handleSubmit = async (values, { setSubmitting }) => {
        try {
            setSubmitting(true);
            await UPDATE_INMUEBLE(inmueble?.id, values);
            toast.success("Agregado correctamente");
            refetch();
            onClose();
        } catch (error) {
            console.error(error);
            toast.error("Error al actualizar");
        } finally {
            setSubmitting(false);
        }
    };

    const initialValues = {
        name: inmueble.name || "",
        address: inmueble.address || "",
        type: inmueble.type || "",
    };

    const validationSchema = Yup.object({
        name: Yup.string().required("El nombre es obligatorio"),
        address: Yup.string().required("La dirección es obligatoria"),
        type: Yup.string().required("La clasificación es obligatoria"),
    });

    return (
        <Formik initialValues={initialValues} onSubmit={handleSubmit} validationSchema={validationSchema}>
            {({ values, isSubmitting, setFieldValue }) => (
                <Form className="flex flex-col justify-center items-center gap-5">
                    <div className="w-full flex flex-col border border-gray-500 bg-gray-100 p-4 rounded-md">
                        <SubHeading text="Datos generales" color="black" />
                        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 rounded-md">
                            <InputField name="name" label="Nombre" placeholder="Nombre de usuario" />
                            <div className="w-full">
                                <label htmlFor="type" className="block text-sm font-medium text-gray-700 mb-1">
                                    Clasificación
                                </label>
                                <Select
                                    name="type"
                                    options={optionsTypesInmuebles}
                                    value={optionsTypesInmuebles.find(option => option.value === values.type) || null}
                                    onChange={(selected) =>
                                        setFieldValue("type", selected ? selected.value : "")
                                    }
                                    className="h-fit border border-blue-600 rounded-md"
                                    classNamePrefix="select"
                                    placeholder="Selecciona clasificación..."
                                    isClearable
                                />
                            </div>
                            <InputField name="address" label="Dirección" placeholder="Direccion del inmueble" />
                        </div>
                    </div>
                    <Button
                        text={isSubmitting ? <PropagateLoader color="red" /> : "Guardar cambios"}
                        type="submit"
                        bgColor="blue"
                        disabled={isSubmitting}
                    />
                </Form>
            )}
        </Formik>
    );
};

export default InmueblesEdit;
